module.exports = __webpack_public_path__ + "static/img/tc2.c80bd13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tc2.jpg
// module id = WC+k
// module chunks = 1